import { logout } from '../modules/auth/actions/auth';
import DisconnectError from '../modules/common/utils/DisconnectError';

class ApiClient {
  /**
   * Default headers
   *
   * @type {Object}
   */
  static headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  /**
   * Available API routes
   *
   * @type {Object}
   */
  static ROUTES = {
    login: '/login-check',
  };

  /**
   * @param {String} host
   * @param {Object} store
   */
  constructor(host, store) {
    this.host = host;
    this.store = store;
    this.token = null;

    this.onError = this.onError.bind(this);
    this.setToken = this.setToken.bind(this);
  }

  /**
   * Request login
   *
   * @param {String}   email
   * @param {String}   password
   * @param {Function} success
   * @param {Function} failure
   *
   * @return {Object}
   */
  login(username, password, success, failure) {
    this.call('POST', ApiClient.ROUTES.login, { username, password }, {})
      .then(result => (result.ok ? success(result.data) : failure(result.data)), failure);
  }

  /**
   * Get authorization header
   *
   * @return {Object}
   */
  getAuthHeader() {
    return {
      Authorization: `Bearer ${this.token}`,
    };
  }

  /**
   * Create an HTTP call
   *
   * @param {String}  method
   * @param {String}  path
   * @param {Object?} data
   * @param {Object}  headers
   *
   * @return {Promise}
   */
  call(method, path, data = null, headers = this.getAuthHeader()) {
    let ok;
    let status;
    const url = `${this.host}${path}`;
    const params = {
      headers: Object.assign(headers, ApiClient.headers),
      method,
    };

    if (data) {
      params.body = JSON.stringify(data);
    }

    return fetch(url, params)
      .then((response) => {
        ok = response.ok;
        status = response.status;

        const contentType = response.headers.get('Content-Type').toLowerCase().split(';')[0];

        switch (contentType) {
          case 'application/json':
          case 'application/problem+json':
            return response.clone().text().then((value) => {
              if (value.length === 0) {
                return null;
              }

              return response.json();
            });

          default:
            return response.text();
        }
      })
      .then((responseData) => {
        if (responseData.code === 401) {
          this.store.dispatch(logout(true));
           throw new DisconnectError(responseData.message);
        }

        return {
          ok,
          status,
          data: responseData,
        };
      })
      .catch(this.onError)
    ;
  }

  /**
   * On error
   *
   * @param {String} error
   *
   * @throws {Error}
   */
  onError(error) {
    throw new Error(error);
  }

  /**
   * Set authentication token
   *
   * @param {String} token
   */
  setToken(token) {
    this.token = token;
  }
}

export default ApiClient;



// WEBPACK FOOTER //
// ./src/api/ApiClient.js